// frontend/store/store.ts
import { configureStore } from '@reduxjs/toolkit';
import sectionReducer from './slices/sectionSlice';
import themeReducer from './slices/themeSlice';
import filesReducer from './slices/fileSlice';
import kbReducer from './slices/kbSlice';
import modelReducer from './slices/modelSlice';
import chatReducer from './slices/chatSlice';
import sessionReducer from './slices/sessionSlice';
import pdfReducer from './slices/pdfSlice';
import docGenReducer from './slices/docGenSlice';
import fileProcessingReducer from './slices/fileProcessingSlice';
import languageReducer from './slices/languageSlice';
import chatHistoryReducer from './slices/chatHistorySlice';
import voiceReducer from './slices/voiceSlice';
import backgroundReducer from './slices/backgroundSlice';
import researchReducer from './slices/researchSlice';
const store = configureStore({
  reducer: {
    section: sectionReducer,
    theme: themeReducer,
    files: filesReducer,
    background: backgroundReducer,
    kb: kbReducer,
    model: modelReducer,
    chat: chatReducer,
    session: sessionReducer,
    pdf: pdfReducer,
    docGen: docGenReducer,
    fileProcessing: fileProcessingReducer,
    language: languageReducer,
    chatHistory: chatHistoryReducer,
    voice: voiceReducer,
    research: researchReducer,
  },
  devTools: {
    trace: true,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
// Selector to get the session state
export const getSessionState = (state: RootState) => state.session;

export type AppStore = typeof store;

export default store;